// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container {
  padding: 8px 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.view-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  margin-bottom: 8px;
}
.view-toolbar__count {
  font-family: var(--font);
  font-weight: 400;
  font-size: 13px;
  opacity: 0.7;
}
.view-toolbar__toggle {
  display: flex;
  gap: 2px;
}
.view-toolbar__toggle ion-button {
  --padding-start: 8px;
  --padding-end: 8px;
  width: 36px;
  height: 36px;
  opacity: 0.4;
  transition: opacity 0.2s ease;
}
.view-toolbar__toggle ion-button.active {
  opacity: 1;
}
.view-toolbar__toggle ion-button ion-icon {
  font-size: 20px;
}

@media (prefers-reduced-motion: reduce) {
  .view-toolbar__toggle ion-button {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/gallery-folder/gallery-folder.page.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;AACF;AACE;EACE,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AACJ;AAEE;EACE,aAAA;EACA,QAAA;AAAJ;AAEI;EACE,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;AAAN;AAEM;EACE,UAAA;AAAR;AAGM;EACE,eAAA;AADR;;AAOA;EACE;IACE,gBAAA;EAJF;AACF","sourcesContent":[".page-container {\n  padding: 8px 12px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.view-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 0 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  margin-bottom: 8px;\n\n  &__count {\n    font-family: var(--font);\n    font-weight: 400;\n    font-size: 13px;\n    opacity: 0.7;\n  }\n\n  &__toggle {\n    display: flex;\n    gap: 2px;\n\n    ion-button {\n      --padding-start: 8px;\n      --padding-end: 8px;\n      width: 36px;\n      height: 36px;\n      opacity: 0.4;\n      transition: opacity 0.2s ease;\n\n      &.active {\n        opacity: 1;\n      }\n\n      ion-icon {\n        font-size: 20px;\n      }\n    }\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .view-toolbar__toggle ion-button {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
